import { useEffect, useState } from 'react';
import {
  checkIfValid,
  getPreviewSelection,
  type PreviewSelection,
  type PreviewSelectionList,
} from './helpers';

export const useValidPreviewSelection = ({
  questions,
  quotaGroups,
  setSurveyPreviewSelection,
}: PreviewSelectionList & {
  setSurveyPreviewSelection: (value: React.SetStateAction<PreviewSelection>) => void;
}) => {
  useEffect(() => {
    setSurveyPreviewSelection((prev) => {
      if (!prev) return getPreviewSelection({ questions, quotaGroups });
      const { questionId, quotaGroupId } = prev;
      const questionIsValid = checkIfValid(questions, questionId);
      const quotaGroupIsValid = checkIfValid(quotaGroups, quotaGroupId);
      if (questionIsValid && quotaGroupIsValid) return prev;
      return getPreviewSelection({ questions, quotaGroups });
    });
  }, [questions, quotaGroups, setSurveyPreviewSelection]);
};

export const usePreviewSelection = ({ questions, quotaGroups }: PreviewSelectionList) => {
  const [surveyPreviewSelection, setSurveyPreviewSelection] = useState(() =>
    getPreviewSelection({ questions, quotaGroups })
  );

  const handleUpdatePreviewQuotaGroup = (quotaGroupId: string | number) => {
    setSurveyPreviewSelection((prev) => {
      return {
        ...prev,
        quotaGroupId,
      };
    });
  };

  const handleUpdatePreviewQuestion = (questionId: number) => {
    setSurveyPreviewSelection((prev) => {
      return {
        ...prev,
        questionId,
      };
    });
  };

  const resetPreviewSelection = () =>
    setSurveyPreviewSelection(() => getPreviewSelection({ questions, quotaGroups }));

  return [
    surveyPreviewSelection,
    setSurveyPreviewSelection,
    handleUpdatePreviewQuestion,
    handleUpdatePreviewQuotaGroup,
    resetPreviewSelection,
  ];
};
